<template>
  <div class="container">
    <div class="flex_space_between search_box">
      <div class="flex_start">
        <!-- <div class="flex_start_center mr_24">
          <div class="mr_12">设备CCID：</div>
          <div>
            <el-input placeholder="请输入" v-model="searchForm.ccid"></el-input>
          </div>
        </div> -->
        <div class="flex_start_center mr_24">
          <div class="mr_12">床位号：</div>
          <div>
            <el-input placeholder="请输入" v-model="searchForm.bed_number"></el-input>
          </div>
        </div>
        <div class="flex_start_center mr_24">
          <div class="mr_12">患者住院号：</div>
          <div>
            <el-input placeholder="请输入" v-model="searchForm.patient_id"></el-input>
          </div>
        </div>
        <el-button type="primary" @click="search">查询</el-button>
        <el-button type="warning" @click="reset">重置</el-button>
      </div>
    </div>
    <el-table :data="tableData" v-loading="loading" align="center" border>
      <el-table-column prop="name" label="患者姓名" align="center"></el-table-column>
      <el-table-column prop="patient_id" label="住院号" align="center"></el-table-column>
      <el-table-column prop="bed_number" label="床位号" align="center"></el-table-column>
      <el-table-column prop="sleep_time" label="昨日睡眠时长（小时）" align="center"></el-table-column>
      <el-table-column prop="deep_sleeping" label="深度睡眠（小时）" align="center"></el-table-column>
      <el-table-column prop="moderate_sleep" label="中度睡眠（小时）" align="center"></el-table-column>
      <el-table-column prop="light_sleep" label="轻度睡眠（小时）" align="center"></el-table-column>
      <el-table-column label="操作" align="center">
        <template slot-scope="scope">
          <el-button plain type="primary" size="small" @click="sleepReport(scope.row)">睡眠数据及分析</el-button>
        </template>
      </el-table-column>
    </el-table>

    <div class="block">
      <el-pagination @size-change="handleSizeChange" @current-change="handleCurrentChange" :current-page="page"
        :page-sizes="[10, 15, 20, 25]" :page-size="perPage" layout="total, sizes, prev, pager, next, jumper"
        :total="total"></el-pagination>
    </div>

    <el-dialog :visible.sync="reportDialogFlag" width="750px" :top="!noData ? '10vh' : '15vh'">
      <div slot="title" class="flex_start_center">
        <div class="custom_title">{{ reportPatientItme.bed_number }}床 {{ reportPatientItme.name }}</div>
        <div>
          <el-date-picker size="small" v-model="reportDate" type="date" placeholder="选择日期"
            :picker-options="pickerOptions" @change="dateChange"></el-date-picker>
        </div>
      </div>

      <div v-show="noData" class="nodata" v-loading="dialogLoading">
        <img src="@/assets/icon/nodata.png" />
        <div>暂无数据，请提醒患者坚持佩戴久乐表！</div>
      </div>
      <div v-show="!noData">
        <div class="dialog_body" v-loading="dialogLoading">
          <div class="today_box" v-if="!todayNoData">
            <div class="flex_space_between today_detail">
              <div>
                <div class="mb_12">
                  <span class="score_text">{{ reportData.info.sleep_score }}</span>
                  <span>分</span>
                </div>
                <div>睡眠质量：不错</div>
              </div>
              <div>
                <div class="mb_12 fs_0">
                  <span class="letter_space">总睡</span>
                  <span>眠：{{ reportData.info.total_sleep_time.toFixed(1) }}H</span>
                </div>
                <div class="mb_12">有效睡眠：{{ reportData.info.real_sleep_time.toFixed(1) }}H</div>
                <div>最大深睡：{{ reportData.info.max_deep_sleep.toFixed(1) }}H</div>
              </div>
              <div>
                <div class="mb_12">轻度睡眠：{{ reportData.info.light_sleep_time.toFixed(1) }}H</div>
                <div class="mb_12">中度睡眠：{{ reportData.info.mid_sleep_time.toFixed(1) }}H</div>
                <div>深度睡眠：{{ reportData.info.deep_sleep_time.toFixed(1) }}H</div>
              </div>
            </div>
            <div class="level_box green_level_box" v-if="reportData.info.risk_of_snoring == '低风险'">
              <div>低风险</div>
              <div class="level_bg_box">
                <img src="@/assets/icon/bed_bg_green.png" alt class="level_bg" />
                <div>
                  <img src="@/assets/icon/bed_green.png" class="bed_icon" />
                  <span>夜间鼾症风险程度</span>
                </div>
              </div>
            </div>
            <div class="level_box blue_level_box" v-if="reportData.info.risk_of_snoring == '中风险'">
              <div>中风险</div>
              <div class="level_bg_box">
                <img src="@/assets/icon/bed_bg_blue.png" alt class="level_bg" />
                <div>
                  <img src="@/assets/icon/bed_blue.png" class="bed_icon" />
                  <span>夜间鼾症风险程度</span>
                </div>
              </div>
            </div>
            <div class="level_box red_level_box" v-if="reportData.info.risk_of_snoring == '高风险'">
              <div>高风险</div>
              <div class="level_bg_box">
                <img src="@/assets/icon/bed_bg_red.png" alt class="level_bg" />
                <div>
                  <img src="@/assets/icon/bed_red.png" class="bed_icon" />
                  <span>夜间鼾症风险程度</span>
                </div>
              </div>
            </div>
          </div>
          <div class="today_nodata" v-else>
            <img src="@/assets/icon/nodata.png" />
            <div>当日暂无睡眠数据~</div>
          </div>

          <div class="history_sleep_data">
            <div class="flex_space_between">
              <div class="dialog_body_title">睡眠统计</div>
              <div class="flex_start_center legend">
                <div class="radiu radiu_1"></div>
                <div>深度睡眠</div>
                <div class="radiu radiu_2"></div>
                <div>中度睡眠</div>
                <div class="radiu radiu_3"></div>
                <div>轻度睡眠</div>
                <div class="radiu radiu_4"></div>
                <div>无数据</div>
              </div>
            </div>
            <div class="echart_box" id="echart"></div>
          </div>
        </div>
      </div>
    </el-dialog>
    <SleepDialog :dialogVisible="showSleepDialog" :dialogData="patientInfo" @closeDialog="closeDialog">
    </SleepDialog>

  </div>
</template>

<script>
import axios from "axios";
const ReportUrl = process.env.REPORT_API;
const dateFtt = (fmt, date) => {
  //author: meizz
  var o = {
    "M+": date.getMonth() + 1, //月份
    "d+": date.getDate(), //日
    "h+": date.getHours(), //小时
    "m+": date.getMinutes(), //分
    "s+": date.getSeconds(), //秒
    "q+": Math.floor((date.getMonth() + 3) / 3), //季度
    S: date.getMilliseconds(), //毫秒
  };
  if (/(y+)/.test(fmt))
    fmt = fmt.replace(
      RegExp.$1,
      (date.getFullYear() + "").substr(4 - RegExp.$1.length)
    );
  for (var k in o)
    if (new RegExp("(" + k + ")").test(fmt))
      fmt = fmt.replace(
        RegExp.$1,
        RegExp.$1.length == 1 ? o[k] : ("00" + o[k]).substr(("" + o[k]).length)
      );
  return fmt;
};
const time = new Date("2024/5/15 00:00:00").getTime();

import SleepDialog from './components/sleepDialog.vue';
export default {
  data() {
    return {
      searchForm: {
        bed_number: "",
        patient_id: "",
      },
      page: 1,
      perPage: 10,
      total: 0,
      tableData: [],
      loading: false,
      zone_number: "",
      reportDialogFlag: false,
      reportPatientItme: {},
      reportDate: "",
      pickerOptions: {
        disabledDate(date) {
          return new Date() < date;
        },
      },
      dialogLoading: false,
      noData: true,
      patient_item: {},
      reportData: {},
      options: {
        tooltip: {
          backgroundColor: "rgba(0,0,0,.7)",
        },
        grid: {
          left: "8%",
          right: "4%",
          bottom: "10%",
          top: "5%",
        },
        xAxis: {
          type: "value",
          max: 144,
          min: 0,
          interval: 12,
          axisLabel: {
            formatter: (params) => {
              // console.log(params);
              return dateFtt("hh:mm", new Date(params * 600000 + time));
            },
          },
          splitLine: {
            show: false,
          },
          axisTick: {
            //x轴刻度相关设置
            alignWithLabel: true,
          },
        },
        yAxis: {
          type: "category",
          data: [],
          splitLine: {
            show: true,
          },
          axisLine: {
            show: false,
          },
          axisTick: {
            show: false,
          },
          zlevel: 2,
        },
        series: [],
        y_data: [],
        keyArr: [],
      },
      patientInfo: {},
      showSleepDialog: false

    };
  },
  components:{
    SleepDialog
  },

  mounted() {
    if (!this.$cookies.get("token")) {
      this.$router.push("/login");
    }
    this.zone_number = this.$cookies.get("zone_number");
    this.fetchData();
  },
  computed: {
    todayNoData() {
      return this.reportData.info == "当日无睡眠数据" || !this.reportData.info;
    },
  },
  methods: {
    reset() {
      this.searchForm.bed_number = "";
      this.searchForm.patient_id = "";
      this.page = 1;
      this.fetchData();
    },
    search() {
      this.page = 1;
      this.fetchData();
    },
    handleSizeChange(e) {
      this.perPage = e;
      this.page = 1;
      this.fetchData();
    },
    handleCurrentChange(e) {
      this.page = e;
      this.fetchData();
    },
    fetchData() {
      this.loading = true;
      let data = {
        page: this.page,
        perPage: this.perPage,
        zone_number: this.zone_number,
        bed_number: this.searchForm.bed_number,
        patient_id: this.searchForm.patient_id,
      };
      if (data.bind == "0") {
        delete data.bind;
      }
      this.$http({
        url: "/api/report/sleep_list",
        method: "POST",
        params: data,
        headers: {
          Token: this.$cookies.get("token"),
        },
      }).then((res) => {
        const result = res.result;
        this.tableData = result.data;
        this.total = result.total;
        this.loading = false;
      });
    },
    // sleepReport(item) {
    //   this.reportPatientItme = item;
    //   this.reportDialogFlag = true;
    //   this.reportDate = new Date();
    //   this.patient_item = item;
    //   this.fecthReportData();
    // },
    // 新版报告
    sleepReport(patientInfo) {
      this.patientInfo = patientInfo;
      this.showSleepDialog = true;
    },
    closeDialog() {
      this.showSleepDialog = false;
    },

    fecthReportData() {
      this.dialogLoading = true;
      let date = this.$dateFtt.dateFtt("yyyyMMdd", this.reportDate);
      axios
        .get(ReportUrl + "/hospital_show/api/report/sleep_report", {
          params: {
            date: date,
            patient_id: this.patient_item.patient_id,
            md5: this.md5Str(this.patient_item.patient_id),
            // date: "20240509",
            // patient_id: "60015158917",
            // md5: this.md5Str("60015158917"),
          },
        })
        .then((response) => {
          const result = response.data;
          if (result.state == 200) {
            this.reportData = result;
            this.noData = false;
            this.setEchart(result.sleep_draw_pic_info);
          } else {
            this.noData = true;
          }
        })
        .catch((error) => {
          console.log(error);
          this.noData = true;
        })
        .finally(() => {
          setTimeout(() => {
            this.dialogLoading = false;
          }, 100);
        });
    },
    setEchart(data) {
      this.y_data = [];
      let series_data = [];
      this.keyArr = [];
      for (const key in data.sleep_draw) {
        // let i = 0;
        if (Object.hasOwnProperty.call(data.sleep_draw, key)) {
          const element = data.sleep_draw[key];
          this.keyArr.push(key);
          this.y_data.push(this.$dateFtt.dateFtt("MM/dd", new Date(key)));
          for (let index = 0; index < element.length; index++) {
            const value = element[index];
            series_data[index] = {
              type: "bar",
              data: [1, 1, 1, 1, 1, 1, 1],
              stack: "total",
              zlevel: 1,
              itemStyle: {
                color: (params) => {
                  // console.log(this.keyArr,this.y_data);
                  let value =
                    data.sleep_draw[
                    this.keyArr[this.y_data.indexOf(params.name)]
                    ][params.seriesIndex];
                  // console.log(value);
                  if (value == 10) {
                    return "#424FA3";
                  } else if (value == 9) {
                    return "#6377F5";
                  } else if (value > 0) {
                    return "#C9D0FF";
                  } else {
                    return "#ffffff00";
                  }
                },
              },
            };
          }
        }
        this.options.yAxis.data = this.y_data;
        this.options.series = series_data;
        // i++;
      }
      this.options.formatter = (params) => {
        let html = "";
        let rangeList = this.reportData.sleep_draw_pic_info.sleep_range;
        let dataList = this.reportData.sleep_draw_pic_info.sleep_draw;
        // console.log(this.reportData.sleep_draw_pic_info.sleep_range);
        for (const key in rangeList) {
          if (Object.hasOwnProperty.call(rangeList, key)) {
            const element = rangeList[key];
            if (this.keyArr[this.y_data.indexOf(params.name)] == element.date) {
              if (
                params.seriesIndex >= element.in_sleep_index &&
                params.seriesIndex <= element.out_sleep_index
              ) {
                if (element.in_sleep_time) {
                  html += `<div style="color:#fff;">入睡时间：${element.in_sleep_time}</div>`;
                }
                if (element.out_sleep_time) {
                  html += `<div style="color:#fff;">出睡时间：${element.out_sleep_time}</div>`;
                }
              }
            }
          }
        }
        // console.log(html);
        return html;
      };
      var chartDom = document.getElementById("echart");
      var myChart = echarts.init(chartDom);
      this.options && myChart.setOption(this.options);
    },
    dateChange() {
      this.fecthReportData();
    },
  },
};
</script>
<style scoped>
.custom_title {
  color: #252b50;
  font-size: 18px;
  font-weight: bolder;
  margin-right: 20px;
}

.mb_24 {
  margin-bottom: 24px;
}

.dialog_body {
  width: 100%;
}

.dialog_body_title {
  color: #252b50;
  font-weight: bold;
  font-size: 16px;
}

.nodata {
  text-align: center;
  padding: 40px 0 60px;
  font-size: 14px;
  color: #929faf;
}

.nodata img {
  width: 162px;
}

.today_nodata img {
  width: 162px;
}

.today_nodata {
  text-align: center;
  padding: 10px 0;
  font-size: 14px;
  color: #929faf;
}

.letter_space {
  letter-spacing: 0.5em;
}

.today_detail {
  height: 132px;
  background: #f5f7fb;
  border-radius: 8px;
  color: #636676;
  padding: 0 52px;
  font-size: 16px;
  margin-bottom: 12px;
}

.today_detail span {
  font-size: 16px;
}

.mb_12 {
  margin-bottom: 12px;
}

.score_text {
  font-weight: bold;
  font-size: 60px !important;
  color: #252b50;
  display: inline-block;
  height: 70px;
}

.fs_0 {
  font-size: 0px;
}

.level_box {
  height: 60px;
  width: 100%;
  line-height: 60px;
  text-align: right;
  padding-right: 40px;
  font-weight: bold;
  font-size: 32px;
  border-radius: 8px;
  position: relative;
}

.green_level_box {
  color: #07c160;
  background-color: #dcfaef;
}

.blue_level_box {
  color: #0076f6;
  background-color: #ebf4ff;
}

.red_level_box {
  color: #e24040;
  background-color: #fdf0f0;
}

.level_bg_box {
  position: absolute;
  width: 50%;
  height: 68px;
  left: 0;
  bottom: 0;
  border-radius: 8px;
  color: #fff;
  font-size: 16px;
  padding-left: 40px;
  font-weight: 500;
}

.level_bg_box div {
  display: flex;
  justify-content: flex-start;
  position: relative;
  align-items: center;
  width: 100%;
  height: 100%;
  z-index: 2;
}

.level_bg {
  position: absolute;
  width: 100%;
  left: 0;
  height: 100%;
  top: 0;
  z-index: 1;
}

.bed_icon {
  width: 32px;
  height: 32px;
  margin-right: 12px;
}

.history_sleep_data {
  margin-top: 12px;
  border: 1px solid #f5f7fb;
  border-radius: 8px;
  padding: 24px 24px 0;
}

.legend {
  color: #9296af;
  font-size: 14px;
}

.radiu {
  width: 10px;
  height: 10px;
  border-radius: 10px;
  margin-left: 20px;
  margin-right: 4px;
  border: 1px solid rgb(214, 214, 214);
}

.radiu_1 {
  background-color: #424fa3;
}

.radiu_2 {
  background-color: #6377f5;
}

.radiu_3 {
  background-color: #c9d0ff;
}

.radiu_4 {
  background-color: #ffffff;
}

.echart_box {
  width: 660px;
  height: 320px;
}
</style>


// WEBPACK FOOTER //
// src/view/managePages/sleep_report.vue